import * as types from '../constants/actions';
import config from '../resources/js/config.js';
import * as MessageActions from '../actions/message';
import * as OverlayActions from '../actions/overlay';
import fetch from 'isomorphic-fetch';
import async from 'async';

export function updateHeight(value) {
  return {
    type: types.CITIES_LIST_SET_HEIGHT,
    value
  };
}

export function setStatesList(values) {
  return {
    type: types.CITIES_LIST_SET_STATES,
    value: values
  };
}

export function setCitiesList(values) {
  return {
    type: types.CITIES_LIST_SET_LIST,
    value: values
  };
}

export function setSelectedState(values) {
  return {
    type: types.CITIES_LIST_SET_SELECTED_STATE,
    value: values
  };
}

export function setSelectedCity(values) {
  return {
    type: types.CITIES_LIST_SET_SELECTED_CITY,
    value: values
  };
}

export function selectCity(values,history) {
  return function (dispatch, getCity) {
    dispatch(setSelectedCity(values));
    history.push(`/admin-cities-edit`)
  }
}

export function getInitialData() {
  let _uri = config.server;

  return function (dispatch, getCity) {
    let _results={};

    const start = function(cb) {
      dispatch(OverlayActions.show());
      cb(null,null);
    };

    const end = function() {
      dispatch(OverlayActions.hide());
    };

    const getCities = function(data, cb) {
      fetch(_uri + '/api/cities',
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ` + localStorage.getItem('token'),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
        }
      )
      .then(function(response) {
        if (!response.ok) {
          if (response.status < 500) {
            response.json()
            .then(data => {
              cb(new Error(data.message));
            })
          } else {
            cb(new Error(response.statusText));
          }
        } else {
          if (response.status === 200) {
            response.json()
            .then(data => {
              _results.cities=data;
              cb(null,data);
            })
          } else {
            cb(null,[]);
          }
        }
      })
      .catch(err => {
        cb(err);
      });
    };

    const getStates = function(data, cb) {
      fetch(_uri + '/api/states',
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ` + localStorage.getItem('token'),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
        }
      )
      .then(function(response) {
        if (!response.ok) {
          if (response.status < 500) {
            response.json()
            .then(data => {
              cb(new Error(data.message));
            })
          } else {
            cb(new Error(response.statusText));
          }
        } else {
          if (response.status === 200) {
            response.json()
            .then(data => {
              _results.states=data;
              cb(null,data);
            })
          } else {
            cb(null,[]);
          }
        }
      })
      .catch(err => {
        cb(err);
      });
    };

    async.waterfall([
      start,
      getCities,
      getStates,
    ], function (error,result) {
        end();
        if (error) {
          console.log(error);
          dispatch(MessageActions.show(error.message));
        } else {
          dispatch(setStatesList(_results.states));
          dispatch(setCitiesList(_results.cities));
        }
    });
  }
}
